import { Webhook, WebhookRequest } from '@nemuru-eng/js-api-client';

import { AddOrEditWebhookFormType } from '@/components/modules/Webhooks/schemas/AddOrEditWebhookForm.schema';
import { getWebhookAuthorization } from '@/components/modules/Webhooks/services/getWebhookAuthorization';

export class WebhookMap {
  static toWebhookRequest(formValues: AddOrEditWebhookFormType): Omit<WebhookRequest, 'userId'> {
    return {
      target: formValues.target,
      event: 'checkout_session',
      client: 'callback',
      contentType: 'application/json',
      ...getWebhookAuthorization(formValues),
      ...(formValues.additionalPayload && { additionalPayload: JSON.parse(formValues.additionalPayload) }),
    };
  }

  static toForm(webhook: Webhook): AddOrEditWebhookFormType {
    return {
      target: webhook.target,
      ...(webhook.additionalPayload && { additionalPayload: JSON.stringify(webhook.additionalPayload, undefined, 2) }),
      ...getWebhookAuthorization(webhook),
    };
  }
}
